// Hair Welcome Kit — nested cart-drawer add-on.
// Injects a compact "Included Free" panel directly under any cart line item
// whose selling plan is Hair 3-month (691379536161) or 6-month (691379568929).
// Display only; nothing touches checkout.
(function(){
  var PLANS = { '691379536161': true, '691379568929': true };
  var IMG = window.HWKB_IMG || {};

  var CSS = ''
    + '.hwkb-nested{margin-top:10px;padding:10px 0 2px;border-top:1px dashed #d9d3c5;color:#1a1a1a;font-family:inherit}'
    + '.hwkb-nested-head{display:flex;align-items:center;gap:8px;margin-bottom:6px}'
    + '.hwkb-nested-headimg{width:32px;height:32px;border-radius:6px;object-fit:cover;background:#fff;flex-shrink:0;border:1px solid #eae5d9}'
    + '.hwkb-nested-headtext{display:flex;flex-direction:column;line-height:1.15}'
    + '.hwkb-nested-badge{display:inline-block;background:#1a1a1a;color:#fff;font-size:10px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;padding:2px 6px;border-radius:4px;align-self:flex-start;margin-bottom:2px}'
    + '.hwkb-nested-title{font-size:12px;font-weight:600;color:#333}'
    + '.hwkb-nested-list{display:flex;flex-direction:column;gap:4px}'
    + '.hwkb-nested-row{display:flex;align-items:baseline;justify-content:space-between;gap:8px;font-size:12px;line-height:1.3}'
    + '.hwkb-nested-name{color:#1a1a1a}'
    + '.hwkb-nested-price s{color:#9a9a9a;margin-right:6px;font-size:11px}'
    + '.hwkb-nested-free{color:#2f7a3a;font-weight:700;text-transform:uppercase;letter-spacing:.02em;font-size:10px}';

  function ensureStyles(){
    if (document.getElementById('hwkb-nested-style')) return;
    var s = document.createElement('style');
    s.id = 'hwkb-nested-style';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function html(){
    return '<div class="hwkb-nested" data-hwkb-nested>'
      + '<div class="hwkb-nested-head">'
      + '<img class="hwkb-nested-headimg" src="' + (IMG.welcomeKit || '') + '" alt="">'
      + '<div class="hwkb-nested-headtext">'
      + '<span class="hwkb-nested-badge">Included Free</span>'
      + '<span class="hwkb-nested-title">Welcome Kit &middot; arrives with your first order</span>'
      + '</div></div>'
      + '<div class="hwkb-nested-list">'
      + row('Hair Welcome Kit', null)
      + row('Stainless Steel Water Bottle', '$25')
      + row('Signature Scalp Massager', '$20')
      + row('Hair Sticker Set', '$10')
      + '</div></div>';
  }
  function row(name, oldPrice){
    return '<div class="hwkb-nested-row">'
      + '<span class="hwkb-nested-name">' + name + '</span>'
      + '<span class="hwkb-nested-price">' + (oldPrice ? '<s>' + oldPrice + '</s>' : '') + '<span class="hwkb-nested-free">Free</span></span>'
      + '</div>';
  }

  var lastFetch = 0, inflight = null, lastData = null;
  function fetchCart(force){
    var now = Date.now();
    if (!force && lastData && (now - lastFetch) < 400) return Promise.resolve(lastData);
    if (inflight) return inflight;
    inflight = origFetch.call(window, '/cart.js', { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(d){ lastData = d; lastFetch = Date.now(); inflight = null; return d; })
      .catch(function(){ inflight = null; return null; });
    return inflight;
  }

  function planId(item){
    var spa = item.selling_plan_allocation;
    return spa && spa.selling_plan && String(spa.selling_plan.id) || null;
  }

  function drawer(){
    return document.querySelector('[data-modal-id="modal--cart-drawer"]');
  }

  function makeNode(key){
    var wrap = document.createElement('div');
    wrap.innerHTML = html();
    var node = wrap.firstElementChild;
    node.setAttribute('data-hwkb-nested', key);
    return node;
  }

  function sync(){
    var d = drawer();
    if (!d) return;
    ensureStyles();
    fetchCart(false).then(function(cart){
      if (!cart) return;
      var wantedKeys = {};
      cart.items.forEach(function(it){
        if (PLANS[planId(it)]) wantedKeys[it.key] = true;
      });
      // Remove orphans
      d.querySelectorAll('[data-hwkb-nested]').forEach(function(el){
        var k = el.getAttribute('data-hwkb-nested');
        if (!wantedKeys[k]) el.remove();
      });
      // Add missing (append INSIDE the line item card as its last child)
      Object.keys(wantedKeys).forEach(function(key){
        var safe = (window.CSS && CSS.escape) ? CSS.escape(key) : key.replace(/"/g, '\\"');
        var card = d.querySelector('[data-line-item-id="' + safe + '"]');
        if (!card) return;
        var existing = card.querySelector(':scope > [data-hwkb-nested]');
        if (existing) return;
        card.appendChild(makeNode(key));
      });
    });
  }

  var scheduled = false;
  function schedule(force){
    if (scheduled) return;
    scheduled = true;
    setTimeout(function(){
      scheduled = false;
      if (force) lastData = null;
      sync();
    }, 120);
  }

  // Hook cart XHR / fetch
  var origFetch = window.fetch;
  if (origFetch){
    window.fetch = function(input){
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (/\/cart(\/|\.js|\/add|\/update|\/change|\/clear)/.test(url)){
        p.then(function(){ schedule(true); }, function(){});
      }
      return p;
    };
  }
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(m, url){
    if (typeof url === 'string' && /\/cart(\/|\.js|\/add|\/update|\/change|\/clear)/.test(url)){
      this.addEventListener('loadend', function(){ schedule(true); });
    }
    return origOpen.apply(this, arguments);
  };
  ['cart:updated','cart:refresh','cart:build','cart:change','modalsLoaded'].forEach(function(ev){
    document.addEventListener(ev, function(){ schedule(true); });
  });

  // Watch for drawer being injected + line items rendering into it
  var mo = new MutationObserver(function(){
    if (drawer()) { attachDrawerObserver(); schedule(false); }
  });
  mo.observe(document.body, { childList: true, subtree: true });

  var drawerObserved = false;
  var drawerMo = new MutationObserver(function(){ schedule(false); });
  function attachDrawerObserver(){
    if (drawerObserved) return;
    var d = drawer(); if (!d) return;
    drawerMo.observe(d, { childList: true, subtree: true });
    drawerObserved = true;
  }

  function boot(){ attachDrawerObserver(); sync(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

